import request from "./request";

// 首页栏目列表，数据缺失不能直接使用
export const getCourseType = (params) => {
  return request({
    url: `/platform/index/getSubjectByPlatformId?pageNo=1&pageSize=99&platformId=${params.platformId}`,
  });
};

// 通过栏目id获取课程和系列课程
export const getCourses = (params) => {
  return request({
    url: `/platform/index/page/course?pageNo=1&pageSize=99&subjectId=${params.subjectId}`,
  });
};

// 获取系列课程下的普通课程
export const getCourseBySeries = (params) => {
  return request({
    url: `/platform/series/getSeriesCoursePage`,
    params,
  });
};

// 支持传多个系列课id 查系列课下面的课程
export const getCourseByManySeries = (params) => {
  return request({
    url: `/platform/series/getMoreSeriesCourseAllCourse`,
    params,
  });
};

// 获取全部课程
export const getCourseBySubjectIds = (params) => {
  return request({
    url: `/platform/index/page/courseBySubjectIds`,
    params,
  });
};

// 获取系列课中看过的课程数量
export const getSeriesCourseViewCourseNum = (params) => {
  return request({
    url: `/platform/series/getSeriesCourseViewCourseNum`,
    params,
  });
};

// 通过标签获取课程
export const getCourseByTag = (data) => {
  return request({
    url: `/middle/normal/course/searchTagNormalCourse`,
    data,
    method: "POST",
  });
};

// 标签获取系列课程
export const getSeriseCoursePageApi = (data) => {
  return request({
    url: `/platform/seriseCourse/getSeriseCoursePage`,
    data,
    method: "POST",
  });
};

// 获取专栏下已学的课程数量
export const getPlatformSubjectViewCourseNum = (data) => {
  return request({
    url: `/platform/subject/getPlatformSubjectViewCourseNum`,
    data,
    method: "POST",
  });
};

// 收藏
export const addCollect = (data) => {
  return request({
    url: `/collection/addCollect`,
    method: "post",
    data,
  });
};

// 取消收藏
export const cancelCollect = (data) => {
  return request({
    url: `/collection/cancelCollect`,
    method: "post",
    data,
  });
};
